const route = [
    {
        path: '/activity/xsc/index', //小升初专题首页
        component: function (resolve) {
            require(['VIEWS/activity/xsc/index.vue'], resolve);
        }
    }, {
        path: '/activity/xsc/list', //暑假活动试卷列表
        component: function (resolve) {
            require(['VIEWS/activity/xsc/list.vue'], resolve);
        }
    },
]
export default route;
